import router from 'src/router/index.js'
import { useRouteCacheStore } from '@/stores/routeCache'

/**
 * 路由缓存治理守卫（keep-alive 配套，需在 handle.js 之后注册）：
 *
 * - 进入可缓存列表页（meta.keepAlive）：
 *   - 从其下级页返回（from.meta.cacheParent === to.name）→ 保留缓存
 *   - 从其上级下钻进入（to.meta.cacheParent === from.name，多级链路）→ 保留缓存
 *   - 其它来源（菜单、跨页跳转、直输地址）→ 释放所有缓存后重新缓存本页
 * - 进入下级页（meta.cacheParent）→ 保留缓存，链路内自由跳转不清缓存
 * - 进入其它页面（无 keepAlive / cacheParent）→ 释放所有缓存，缓存不长期滞留
 *
 * 注意：meta.parent 已被企业端二级菜单分组占用，缓存父子关系统一用 meta.cacheParent。
 */
router.beforeEach((to, from) => {
  const cacheStore = useRouteCacheStore()
  if (to.meta.keepAlive) {
    const fromChild = from.meta.cacheParent && from.meta.cacheParent === to.name
    const fromParent = to.meta.cacheParent && to.meta.cacheParent === from.name
    if (!fromChild && !fromParent) cacheStore.delAllViews()
    cacheStore.addView(to.name)
  } else if (!to.meta.cacheParent) {
    cacheStore.delAllViews()
  }
})
